import { Application } from "@hotwired/stimulus";

import Header from "./patterns/02-organisms/header";
import HeaderSearch from "./patterns/02-organisms/header-search";
import Toggle from "./patterns/02-organisms/toggle";
import Embla from "./patterns/02-organisms/carousel-embla";
import Subscribe from "./patterns/02-organisms/subscribe";
import Accordion from "./patterns/02-organisms/accordion";
import Scrollbar from "./patterns/02-organisms/scrollbar";

const components = {
    header: Header,
    "header-search": HeaderSearch,
    toggle: Toggle,
    "carousel-embla": Embla,
    subscribe: Subscribe,
    accordion: Accordion,
    scrollbar: Scrollbar,
};

window.Stimulus = Application.start();

Object.keys(components).forEach((component) => {
    Stimulus.register(component, components[component]);
});
